import {
  BENEFICIARY_INSIGHT_DISPLAY_TYPES,
  BeneficiaryInsightDisplayType,
} from '@repo/shared/dtos/beneficiary'
import { Card, CardContent, CardHeader, CardTitle } from '@repo/ui/card'
import { FormControl, FormField, FormItem, FormLabel, FormMessage } from '@repo/ui/form'
import { useT } from '@repo/ui/hooks'
import { Input } from '@repo/ui/input'
import { Label } from '@repo/ui/label'
import { RadioGroup, RadioGroupItem } from '@repo/ui/radio-group'

import { getInsightIcon } from '../list/helpers'
import { FormType } from './types'

export default function GeneralInformationForm({ form }: { form: FormType }) {
  const { t } = useT({ keyPrefix: 'admin.insights.form.generalInformation' })

  return (
    <Card>
      <CardHeader>
        <CardTitle>{t('title')}</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          <FormField
            control={form.control}
            name="title"
            render={({ field }) => (
              <FormItem>
                <FormLabel>{t('form.title')}</FormLabel>
                <FormControl>
                  <Input placeholder={t('form.titlePlaceholder')} {...field} />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />
          <FormField
            control={form.control}
            name="description"
            render={({ field }) => (
              <FormItem>
                <FormLabel>{t('form.description')}</FormLabel>
                <FormControl>
                  <Input placeholder={t('form.descriptionPlaceholder')} {...field} />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />

          <div className="space-y-2">
            <Label>{t('form.displayType')}</Label>
            <RadioGroup
              className="grid grid-cols-4 gap-y-6"
              value={form.getValues('type')}
              onValueChange={(value) =>
                form.setValue('type', value as BeneficiaryInsightDisplayType, {
                  shouldTouch: true,
                  shouldValidate: true,
                  shouldDirty: true,
                })
              }
            >
              {BENEFICIARY_INSIGHT_DISPLAY_TYPES.map((type) => (
                <label
                  key={type}
                  aria-label={type}
                  className="border border-primary-200 rounded-md py-2 px-3 flex flex-col has-[:checked]:bg-primary-50 has-[:checked]:border-primary-400 has-[:checked]:ring-2 has-[:checked]:ring-primary-400 outline-solid cursor-pointer"
                >
                  <RadioGroupItem value={type} className="hidden" />
                  <div className="flex justify-center mb-4">{getInsightIcon(type, 'size-8')}</div>
                  <div className="font-medium text-gray-900 dark:text-white text-sm text-center mb-1">
                    {t(`form.displayTypeOptions.${type}.title`)}
                  </div>
                  <div className="text-xs text-center text-gray-500 dark:text-gray-400 leading-tight">
                    {t(`form.displayTypeOptions.${type}.description`)}
                  </div>
                </label>
              ))}
            </RadioGroup>
          </div>
        </div>
      </CardContent>
    </Card>
  )
}
